import { Route, Navigate } from 'react-router-dom';
import * as Pages from './routePages';
import { DEALER_PAGE_ROLES } from '../lib/roles';
import { RequireRoles, RequireCapability, BlockReps, StrictViewBlock, RoleAwareHome, RoleAwareDashboard } from './routingGuards';
import { NoAccessPage } from '../components/auth/ProfileRouteGuard';
export function workspaceRoutes() {
  return <>
<Route path="/" element={<RoleAwareHome />} />
<Route path="/dashboard" element={<RoleAwareDashboard />} />
<Route path="/reports" element={<Navigate to="/accounting?tab=pl" replace />} />
<Route path="/deals" element={<Navigate to="/leads" replace />} />
<Route path="/deals/:id" element={<Navigate to="/leads" replace />} />
<Route
                  path="/admin/access-requests"
                  element={
                    <RequireRoles
                      roles={[
                        'owner', 'admin', 'manager', 'sales_manager',
                        'operations_manager', 'super_admin',
                      ]}
                    >
                      <Pages.AccessRequestsPage />
                    </RequireRoles>
                  }
                />
<Route
                  path="/admin/call-recordings"
                  element={
                    <RequireRoles roles={['admin', 'owner']}>
                      <Pages.CallRecordingsPage />
                    </RequireRoles>
                  }
                />
<Route
                  path="/admin/team-performance"
                  element={
                    <RequireRoles roles={['admin', 'owner']}>
                      <Pages.TeamPerformanceAdmin />
                    </RequireRoles>
                  }
                />
<Route
                  path="/admin/employee-report"
                  element={
                    <RequireRoles roles={['admin', 'owner', 'operations_manager']}>
                      <Pages.EmployeeReportCardPage />
                    </RequireRoles>
                  }
                />
<Route
                  path="/admin/sales-targets"
                  element={
                    <RequireRoles roles={['admin', 'owner']}>
                      <Pages.AdminSalesTargetsPage />
                    </RequireRoles>
                  }
                />
<Route
                  path="/admin/call-kpi"
                  element={
                    <RequireRoles roles={['admin', 'owner']}>
                      <Pages.CallKpiDashboard />
                    </RequireRoles>
                  }
                />
<Route
                  path="/admin/system-health"
                  element={
                    <RequireRoles roles={['admin', 'owner']}>
                      <Pages.SystemHealthFleetPage />
                    </RequireRoles>
                  }
                />
<Route path="/coupons/new" element={<Pages.CouponEditor />} />
<Route path="/coupons/:id/edit" element={<Pages.CouponEditor />} />
<Route path="/projects" element={<Pages.ProjectsPage />} />
<Route path="/projects/:id" element={<Pages.ProjectDetailPage />} />
<Route path="/tasks" element={<Pages.TasksPage />} />
<Route path="/calendar" element={<Pages.CalendarPage />} />
<Route path="/material-boxes" element={<Pages.MaterialBoxesPage />} />
<Route path="/integrations/tally-sync" element={<Pages.TallySyncPage />} />
<Route path="/veda-agro/samples" element={<Pages.SamplesPage />} />
<Route path="/veda-agro/landed-cost" element={<Pages.LandedCostPage />} />
<Route path="/veda-agro/invoice-swap" element={<Pages.InvoiceSwapPage />} />
<Route path="/veda-agro/financial-approvals" element={<Pages.FinancialApprovalsListPage />} />
<Route path="/veda-agro/security-payments" element={<Pages.SecurityPaymentPage />} />
<Route path="/veda-agro/deal-closure" element={<Pages.DealClosurePage />} />
<Route path="/veda-agro/tally-sync" element={<Pages.TallySyncPage />} />
<Route path="/veda-agro/leads" element={<Navigate to="/leads" replace />} />
<Route path="/veda-agro/deals" element={<Navigate to="/deals" replace />} />
<Route path="/veda-agro/po-create" element={<Navigate to="/purchase-orders/new" replace />} />
<Route path="/veda-agro/supplier-quotes" element={<Navigate to="/quotation-jobs" replace />} />
<Route path="/veda-agro/truck-tracking" element={<Navigate to="/logistics/tracker" replace />} />
<Route path="/veda-agro/payments" element={<Navigate to="/payments" replace />} />
<Route path="/veda-agro/advances" element={<Navigate to="/payments?tab=advances" replace />} />
<Route path="/veda-agro/invoice-upload" element={<Navigate to="/payments" replace />} />
<Route path="/veda-agro/margin-report" element={<Navigate to="/analytics?view=margin" replace />} />
<Route path="/payment-gate" element={<Pages.PaymentGatePage />} />
<Route path="/field-partners" element={<Pages.FieldPartnerDirectoryPage />} />
<Route path="/field-partners/kyc-review" element={<Pages.KycReviewPage />} />
<Route path="/field-partners/claims" element={<Pages.InstallationClaimsPage />} />
<Route path="/field-partners/incentive-rules" element={<Pages.IncentiveRulesPage />} />
<Route path="/field-partners/payouts" element={<Pages.PayoutsConsolePage />} />
<Route path="/field-partners/fraud-review" element={<Pages.FraudReviewPage />} />
<Route path="/field-partners/config" element={<Pages.FieldProgramConfigPage />} />
<Route path="/escalation-rules" element={<Pages.EscalationRulesPage />} />
<Route path="/field-activity" element={<Pages.FieldActivityPage />} />
<Route path="/field-sessions" element={<Pages.FieldSessionsPage />} />
<Route path="/field-agents" element={<Pages.FieldAgentsPage />} />
<Route path="/field-agents/:userId" element={<Pages.FieldAgentDetailPage />} />
<Route path="/admin/field-ta-da-rates" element={<Pages.FieldTaDaRatesPage />} />
<Route path="/finance/tada-claims" element={<Pages.TaDaClaimsPage />} />
<Route path="/support/my" element={<Pages.MySupportPage />} />
<Route path="/support/tickets" element={<Pages.SupportTicketsPage />} />
<Route path="/support/tickets/:id" element={<Pages.SupportTicketDetailPage />} />
<Route path="/support/bug-tests" element={<Pages.BugTestDashboardPage />} />
<Route path="/support/bug-tests/:id" element={<Pages.BugTestDetailPage />} />
<Route path="/workflows" element={<Pages.WorkflowsPage />} />
<Route path="/analytics" element={<BlockReps><Pages.AnalyticsPage /></BlockReps>} />
<Route path="/ai" element={<Pages.AIAssistantPage />} />
<Route path="/ai/agents" element={<Pages.AIAgentsPage />} />
<Route path="/ai/integrations" element={<Pages.APIIntegrationsPage />} />
<Route path="/credits" element={<Pages.CreditsPage />} />
<Route path="/proposal-builder" element={<BlockReps><Pages.ProposalBuilderPage /></BlockReps>} />
<Route path="/knowledge-base" element={<Pages.KnowledgeBasePage />} />
<Route path="/admin" element={<Pages.SuperAdminDashboard />} />
<Route path="/admin/tenants" element={<Pages.TenantManagementPage />} />
<Route path="/admin/billing" element={<Pages.BillingPage />} />
<Route path="/admin/health" element={<Pages.SystemHealthPage />} />
<Route path="/admin/team" element={<Pages.TeamPage />} />
<Route path="/admin/audit-logs" element={<Pages.AuditLogsPage />} />
<Route path="/admin/resources" element={<Pages.ResourceManagement />} />
<Route path="/admin/lead-approvals" element={<Pages.AdminLeadApprovalsPage />} />
<Route path="/admin/settings" element={<StrictViewBlock><Pages.AdminSettingsPage /></StrictViewBlock>} />
<Route path="/admin/permissions" element={<StrictViewBlock><Pages.PermissionsPage /></StrictViewBlock>} />
<Route path="/admin/follow-ups" element={<Pages.FollowUpsAdminPage />} />
<Route path="/admin/announcements" element={<StrictViewBlock><Pages.AnnouncementsPage /></StrictViewBlock>} />
<Route path="/admin/carrier-numbers" element={<Pages.CarrierNumbersPage />} />
<Route path="/admin/installations" element={<Pages.InstallationsFocusPage />} />
<Route path="/admin/proposal-builder" element={<BlockReps><Pages.AdminProposalBuilderPage /></BlockReps>} />
<Route path="/admin/product-specs" element={<Pages.ProductSpecsPage />} />
<Route path="/admin/lead-router" element={<Pages.LeadRouterPage />} />
<Route path="/admin/lead-router/dealers" element={<Pages.LeadRouterDealerPage />} />
<Route path="/admin/lead-routing" element={<Pages.LeadRoutingPage />} />
<Route path="/admin/calculator-builder" element={<Pages.CalculatorBuilderPage />} />
<Route
                  path="/admin/analytics"
                  element={
                    <RequireRoles
                      roles={[
                        'admin', 'owner', 'super_admin', 'ceo', 'operations_manager',
                        'sr_sales_manager', 'sales_manager', 'manager',
                      ]}
                    >
                      <Pages.AnalyticsDashboardPage />
                    </RequireRoles>
                  }
                />
<Route path="/admin/discount-policies" element={<Pages.DiscountPoliciesPage />} />
<Route path="/admin/pool-models" element={<Pages.PoolModelsAdmin />} />
<Route path="/admin/commercial-heat-pump-models" element={<Pages.CommercialHeatPumpModelsAdmin />} />
<Route path="/admin/ss-tank-models" element={<Pages.SsTankModelsAdmin />} />
<Route path="/admin/domestic-heat-pump-models" element={<Pages.DomesticHeatPumpModelsAdmin />} />
<Route path="/executive/service/tickets" element={<Pages.ExecMyTicketsPage />} />
<Route path="/executive/service/parts-expenses" element={<Pages.ExecPartsAndExpensesPage />} />
<Route path="/executive/production/work-orders" element={<Pages.ExecMyWorkOrdersPage />} />
<Route path="/executive/production/qc-checkpoints" element={<Pages.ExecMyQCCheckpointsPage />} />
<Route path="/executive/warehouse/grn" element={<Pages.ExecGRNQueuePage />} />
<Route path="/executive/warehouse/dispatch" element={<Pages.ExecMyDispatchPage />} />
<Route path="/executive/accounts/match-queue" element={<Pages.ExecMatchQueuePage />} />
<Route path="/executive/accounts/approvals" element={<Pages.ExecApprovalsPage />} />
<Route path="/executive/field-partner/claims" element={<Pages.ExecMyClaimsPage />} />
<Route path="/executive/field-partner/payouts" element={<Pages.ExecMyPayoutsPage />} />
<Route path="/profile" element={<Pages.ProfilePage />} />
<Route path="/account" element={<Navigate to="/profile" replace />} />
<Route path="/settings/ai-assistant" element={<StrictViewBlock><Pages.AIAssistantSettingsPage /></StrictViewBlock>} />
<Route path="/settings/*" element={<StrictViewBlock><Pages.SettingsPage /></StrictViewBlock>} />
<Route path="/billing/plans" element={<Pages.BillingPlansPage />} />
<Route path="/tickets" element={<Navigate to="/service-tickets" replace />} />
<Route path="*" element={<Pages.NotFound />} />
<Route path="/admin/roles" element={<Pages.PermissionsPage />} />
<Route path="/no-access" element={<NoAccessPage />} />
  </>;
}
